export default __webpack_public_path__ + "static/logo-1d750ad176192fa9e00a9961bd337fa3.png";